export class AppConsts {

  static api: {
    baseUrl: string,
    emulatorUrl: string,
    viewerUrl: string,
    reportUrl: string,
    websiteUrl: string,
    hisId: string,
    appName: string,
    loginBackground: string
  };
  static apisso: {
    baseUrl: string
  };
  static pageSize: {
    size: any
  };
  static site: {
    baseUrl: string,
    imageUrl: string
  };
  static page: { basePage: number };
  static defaultPage: { defaultBasePage: number };
  static amountWarningChemical: number;
  static daysWarningChemical: number;

}
